import React from "react";
import classnames from "classnames";

import IconSvg from "components/IconSvg";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  children: any;
  className: string;
  icon: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  style: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  [x: string]: any;
};

const kebabCase = (string: string) =>
  string
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/\s+/g, "-")
    .toLowerCase();

const LabeledItem = React.forwardRef(
  ({ label, children, className, style, icon, ...props }: Props, ref) => {
    const classes = classnames(className, "flex justify-between");
    const dataTestId = props["data-testid"] || kebabCase(label);
    const iconSize = 22;

    return (
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={classes}
        style={{ ...style }}
        data-testid={dataTestId}
        {...props}
      >
        <div className="flex">
          <span>{label} </span>
          {icon && (
            <IconSvg
              filePath={`${icon}.svg`}
              width={`${iconSize}`}
              height={`${iconSize}`}
              className="ml-xs inline-block"
            />
          )}
        </div>
        <span className="" data-testid={`value-${dataTestId}`}>
          {children}
        </span>
      </div>
    );
  },
);

export default LabeledItem;
